import { render, staticRenderFns } from "./DocumentInfoEdit.vue?vue&type=template&id=b9007546"
import script from "./DocumentInfoEdit.vue?vue&type=script&lang=js"
export * from "./DocumentInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports